import { render, staticRenderFns } from "./AccountsSection.vue?vue&type=template&id=09a83c47&"
import script from "./AccountsSection.vue?vue&type=script&lang=js&"
export * from "./AccountsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports